import { Entity } from "./entity";
import { DataResponse } from "./response";

export enum TrialUserFields {
    Uid = 'Uid',
    Email = 'Email',
    FirstName = 'FirstName',
    LastName = 'LastName',
    Status = 'Status',
    DateSent = 'DateSent',
}

export interface TrialUser extends Entity {
    [TrialUserFields.Uid]: string;
    [TrialUserFields.Email]?: string;
    [TrialUserFields.FirstName]?: string;
    [TrialUserFields.LastName]?: string;
    [TrialUserFields.Status]?: string;
    [TrialUserFields.DateSent]?: string;
}

export type TrialUserReadResponse = DataResponse<TrialUser>